<template>
  <div
    :class="{
      'ChooseRide-root': true,
      open: $store.state.rides.pickerOpen
    }"
  >
    <div class="ChooseRide-inner">
      <div
        class="ChooseRide-toggle"
        @click="$store.dispatch('toggleRidePicker')"
      >
        <div class="svg-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="42"
            viewBox="0 0 42 91"
            preserveAspectRatio="none"
          >
            <g fill="none" fill-rule="evenodd">
              <path fill="#FFE857" d="M0 45.5L11.639 0H42v91H11.639L0 45.5z" />
            </g>
          </svg>
        </div>
        <div class="label">
          CHOOSE RIDE
        </div>
      </div>
      <div class="ChooseRide">
        <div class="close-button" @click="$store.dispatch('closeRidePicker')">
          &times;
        </div>
        <ul>
          <li
            v-for="ride in $store.state.rides.rides"
            :key="ride.name"
            :class="{
              ride: true,
              [ride.id]: true,
              selected: ride.id === $store.state.rides.selected
            }"
            @click="$store.dispatch('selectRide', ride.id)"
          >
            <img :src="ride.img" />
          </li>
        </ul>
        <router-link
          class="intro-button nbutton"
          :to="{ name: 'narrative' }"
          @click.native="$store.dispatch('closeRidePicker')"
        >
          <span>REPLAY INTRO</span>
          <ReplayButton />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ReplayButton from "../assets/replay.svg?inline";

export default {
  name: "ChooseRide",
  components: { ReplayButton },
  data() {
    return {
      open: false
    };
  }
};
</script>

<style scoped lang="scss">
@import "@/constants/_variables.scss";

.ChooseRide-root {
  right: -$choose-ride-width - 20px;
  transition: 0.3s right;
  height: calc(100% + 11px);
  top: -5px;
  position: absolute;
  width: $choose-ride-width;

  @media (max-width: $mobile-screen-width) and (orientation: portrait) {
    display: none;
  }

  &.open {
    right: 0;
  }
}

.ChooseRide-inner {
  height: 100%;
  position: relative;
}

.ChooseRide-toggle {
  position: absolute;
  left: -50px;
  bottom: 0;
  top: 0;
  cursor: pointer;
  pointer-events: all;
  padding-right: 40px;
  background-color: $light-gold;
  transition: left 0.5s;

  &:hover {
    left: -70px;
  }

  .svg-wrapper {
    margin-left: -15px;
    height: 100%;
  }

  svg {
    height: 100%;
  }

  .label {
    color: #c04323;
    font-family: Graphik-Regular, Graphik;
    font-size: 16px;
    font-weight: normal;
    left: -82px;
    position: absolute;
    top: calc(50% - 10px);
    transform: rotate(-90deg);
    width: 190px;

    @media (max-height: $mobile-screen-width) {
      font-size: 12px;
      left: -80px;
      top: calc(50% - 8px);
      width: 180px;

      .not-mobile {
        display: none;
      }
    }
  }
}

.ChooseRide-root.open .ChooseRide-toggle {
  left: -50px;
}

.ChooseRide {
  background-color: $light-gold;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  pointer-events: all;
  width: 100%;
}

ul {
  display: flex;
  justify-content: space-around;
  list-style: none;
  margin: 0;
  margin-right: 0.5rem;
  min-height: 50%;
  max-height: 80%;
  padding: 0;

  @media (max-height: $mobile-screen-width) {
    max-height: 70%;
  }
}

.ride {
  align-items: center;
  border: 3px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0.1rem;
  width: 135px;

  img {
    flex-shrink: 1;
    max-height: 100%;
    max-width: 100%;
  }

  .name {
    font-size: 0.9em;
    font-weight: 400;
    margin-top: 0.5rem;

    @media (max-width: $mobile-screen-width) and (orientation: landscape) {
      font-size: 0.7em;
      margin-top: 0.1rem;
    }
  }

  &.truck {
    .name {
      white-space: nowrap;
    }
  }

  &:hover,
  &.selected {
    border-color: $copper;

    .name {
      font-weight: 500;
    }
  }
}

.close-button {
  align-self: flex-end;
  cursor: pointer;
  font-size: 2.5em;
  line-height: 0.5em;
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;

  &:hover {
    color: $dark-red;
  }
}

.intro-button {
  align-items: center;
  align-self: flex-end;
  background: transparent;
  border: 1px solid transparent;
  bottom: 5px;
  color: $copper;
  cursor: pointer;
  display: flex;
  height: 20px;
  padding: 0;
  position: absolute;
  right: 10px;
  text-decoration: none;

  svg {
    height: unset;
    padding-top: 0.1em;

    path {
      fill: $copper;
    }
  }

  &:hover {
    color: $dark-red;

    svg path {
      fill: $dark-red;
    }
  }

  @media (max-width: $mobile-screen-width) and (orientation: landscape) {
    position: absolute;
    bottom: 5px;
    right: 5px;

    .not-mobile {
      display: none;
    }
  }
}
</style>

<style lang="scss">
@import "@/constants/_variables.scss";

.map-view.transitioning,
.map-view .no-map {
  .ChooseRide-root {
    right: -($choose-ride-width) - 75px;
  }
}
</style>
